var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 314.316,
    height: 321.003,
    viewBox: "0 0 314.316 321.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_Copy",
    "data-name": "Path Copy",
    d: "M211.239,308.8a19.276,19.276,0,0,1-7.766,9.543,19.719,19.719,0,0,1-16.207,1.578A19.451,19.451,0,0,1,175.481,308.8L116.2,162.142l9.409,1.393L71.967,308.8A17.536,17.536,0,0,1,55.5,320.909a19.677,19.677,0,0,1-11.763-2.562,20.617,20.617,0,0,1-8-9.543L1.413,215.733A20.911,20.911,0,0,1,0,208.284a19.134,19.134,0,0,1,5.17-13.5A18.282,18.282,0,0,1,19.308,189.2a19.906,19.906,0,0,1,10.339,2.79,15.142,15.142,0,0,1,6.589,9.315L60.665,271.09l-9.882-.468,54.588-139.681a18.158,18.158,0,0,1,17.9-11.645,17.13,17.13,0,0,1,10.586,3.03,17.435,17.435,0,0,1,5.882,8.614l57.392,139.681-11.763.933L277.539,12.107C280.271,3.894,286.009,0,295.434,0a18.183,18.183,0,0,1,12.94,5.116,16.337,16.337,0,0,1,5.878,13.99,13.5,13.5,0,0,1-.7,3.935",
    transform: "translate(0.004 0.002)",
    fill: "#e1efff",
    opacity: 0.273
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogo);
export default __webpack_public_path__ + "static/media/bg-logo.a3156cc4d3e62bd40a81846e0643ee5b.svg";
export { ForwardRef as ReactComponent };